import React from "react"
import { Typography, Card } from "antd"
import { Animated } from "react-animated-css"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../../components/Layout"
import TrustedBy from "../../components/TrustedBy"
import FeaturedWork from "../../components/WEB_FeaturedWork"
import DevelopmentProcess from "../../components/WEB_DevelopmentProcess"
import TechStack from "../../components/WEB_TechStack"
import CtaBanner from "../../components/WEB_CtaBanner"
import SideForm from "../../components/SideForm"
import "../../styles/services.scss"
import "../../styles/animate.css"
import behindImageSmall from "../../images/Group 495@2x.png"
import ServiceCard from "../../components/ServiceCard"
import ServiceStepsProcess from "../../components/ServiceStepsProcess"
import IconsAdded from "../../components/IconsAdded"
import sc_legacy      from "../../images/servicecard/legacy.png"
import sc_ecommerce   from "../../images/servicecard/E-commerce.png"
import sc_ux          from "../../images/servicecard/UIUX design.png"
import sc_growth      from "../../images/servicecard/cloud.png"
import sc_performance from "../../images/servicecard/performance.png"
import sc_integration from "../../images/servicecard/integration.png"
import sc_testing     from "../../images/servicecard/Automated testing.png"
import sc_deployment  from "../../images/servicecard/deployment.png"

const { Title } = Typography

const Index = ({ data }) => {
  const backgroundImage = data.bgImage.childImageSharp.fluid.src
  return (
    <Layout className="services-page-container" data={data} 
    pageTitle={"Visiomate - Web Development Services"}
    descrip = {"From design to deployment, we handle every aspect of web development. Partner with us for innovative, scalable, and engaging web solutions."}>
      <div className="top-section"
        style={{ backgroundImage: `url(${backgroundImage})` }}>
        {/* <div className="logo">
          <Link to="/">
            <Img fluid={data.VMLogoWhite.childImageSharp.fluid} />
          </Link>
        </div> */}
        <div className="box-wrapper text-and-form-container" style={{ gridTemplateColumns: '1fr', textAlign: 'center' }}>
          <div className="information">
            <Animated
              animationIn="fadeInUp"
              animationInDuration={500}
              animationInDelay={300}
              isVisible={true}
            >
              <Title>AI-Powered Web Applications Built for Enterprise Scale</Title>
              <br />
              <p>
                We build enterprise-grade web applications with AI embedded at
                every layer — from intelligent interfaces and automated workflows
                to real-time analytics and predictive features. Our engineering teams pair modern frameworks with AI capabilities
                to deliver applications that don't just perform today, but
                continuously learn and improve — maximising your team's
                productivity and keeping you ahead of the curve.
              </p>
              {/* <TrustedBy showHeading={false} /> */}
            </Animated>
          </div>
          {/* <Animated
            animationIn="fadeInDown"
            animationInDuration={800}
            animationInDelay={500}
            isVisible={true}
            className="form"
          >
            <SideForm />
          </Animated> */}
        </div>
      </div>
      <div className="services-description-section">
      <div className="service-heading-and-detail">
        <Title>We Can Help With</Title>
      </div>
      <div className="service-cards-wrapper">
        <ServiceCard img_src={sc_legacy}      img_alt={'Modernise legacy web systems'}             card_heading={'Modernise Your Legacy System'}    card_para={"Businesses running on outdated portals lose hours every day to manual workarounds. We replace them with AI-augmented web apps built around your exact workflows."}/>
        <ServiceCard img_src={sc_ecommerce}   img_alt={'E-commerce and online store development'}  card_heading={'Sell Smarter Online'}             card_para={"D2C and B2B buyers expect fast, personalised checkout experiences. We build conversion-optimised storefronts with AI-driven product recommendations and real-time inventory."}/>
        <ServiceCard img_src={sc_ux}          img_alt={'UI/UX design for better user experience'}  card_heading={'Cut User Drop-Off'}               card_para={"Poor UX costs revenue. We redesign interfaces using behavioural data and modern design systems so users complete tasks faster and come back more often."}/>
        <ServiceCard img_src={sc_growth}      img_alt={'Scalable cloud-native architecture'}       card_heading={'Build for 10× Growth'}            card_para={"Scaling startups hit a wall when their architecture wasn't designed to grow. We design cloud-native, event-driven systems that handle 10× traffic without rewrites."}/>
        <ServiceCard img_src={sc_performance} img_alt={'High-performance frontend development'}    card_heading={'Performance That Wins Rankings'}  card_para={"Slow frontends kill SEO and frustrate users. We build React-powered interfaces optimised for Core Web Vitals — fast on every device, every network."}/>
        <ServiceCard img_src={sc_integration} img_alt={'Secure API and backend integration'}       card_heading={'Integrate Everything, Securely'}  card_para={"Modern businesses run on 10+ tools. We build secure APIs and backend logic that connect your ERP, CRM, payments, and data sources into one coherent system."}/>
        <ServiceCard img_src={sc_testing}     img_alt={'Automated testing and quality assurance'}  card_heading={'Ship Fast Without Breaking Prod'} card_para={"Teams releasing weekly can't afford manual QA. We build automated test suites that catch regressions before they reach production — keeping your release pipeline green."}/>
        <ServiceCard img_src={sc_deployment}  img_alt={'Cloud deployment and 24/7 support'}        card_heading={'Zero-Downtime Launch & Support'}  card_para={"Going live is only the beginning. We handle cloud deployment, monitoring, and proactive support so you can focus on your business, not your infrastructure."}/>
        <ServiceCard card_heading={'Let connect, book a free consultancy session with our experts'} card_button={"Free Consultancy"} numOfCard='odd'/>
      </div>
        {/* <div className="behindimagediv">
            <img
              className="behindImageSmall"
              src={behindImageSmall}
              alt="yellow-triangle"
            />
            <img className="behindImageLarg" src={behindImageSmall} alt="yellow-triangle" />
        </div> */}
      </div>
      <div className="featured-projects position-relative">
        <FeaturedWork data={data} />
        {/* <IconsAdded/> */}
      </div>
      <DevelopmentProcess title='How We Turn Your Idea Into a Shipped Product' >
        <ServiceStepsProcess process_heading='Inception & Elicitation' process_para="Talk to the customer Listen to what the customer has to say Brainstorm and prepare project backlog" process_step_number="1" process_indentify="odd" />
        <ServiceStepsProcess process_heading='Plan sprint' process_para="The team reviews the product backlog and selects items they believe can be completed within the sprint timeframe" process_step_number="2" />
        <ServiceStepsProcess process_heading='Execute Sprint' process_para="The team focuses on completing the items in the sprint backlog, which consists of tasks selected from the product backlog based on priority and team capacity" process_step_number="3" process_indentify="odd" iconShow="dark"/>
        <ServiceStepsProcess process_heading='Review and Deliver' process_para="During this step, the development team showcases the work completed, demonstrating new features and functionalities to the customer" process_step_number="4" iconShow="dark" />
        <ServiceStepsProcess process_heading='Support & maintenance' process_para="A critical phases in the software development lifecycle, ensuring that applications are successfully launched and maintained for optimal performance" process_step_number="5" process_indentify="odd" />
      </DevelopmentProcess>
      <TechStack />
      <CtaBanner />
    </Layout>
  )
}

export default Index

export const webDevelopmentQuery = graphql`
  query webDevelopmentQuery {
    NurturefulCover: file(relativePath: { eq: "caseStudies/nurturefulth.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    FarmManagementSystem: file(
      relativePath: { eq: "FarmManagementSystem/pf.jpg" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    TenderAssetRecordManagement: file(
      relativePath: { eq: "TenderAssetRecordManagement/tender.jpg" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    ViztosPos: file(relativePath: { eq: "ViztosPos/vistos_image.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Odoo2: file(relativePath: { eq: "Odoo/odoo2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Custom: file(relativePath: { eq: "Custom/CustDevelopment.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    D365_2: file(relativePath: { eq: "D365/D365_2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bgImage: file(relativePath: { eq: "Mask_group8.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    EMS: file(relativePath: { eq: "EMS/ems_side.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Viztos: file(relativePath: { eq: "ViztosPos/viztos_side.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Tender: file(relativePath: { eq: "TenderAssetRecordManagement/trn_side.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`